import { ReactComponent as BurgerSVG } from "../../assets/burger.svg";

function MenuButton({ onClick }) {
  return (
    <div className="menu-button">
      <button type="button" onClick={onClick}>
        <BurgerSVG />
      </button>
    </div>
  );
}

export default MenuButton;
